/**
 * Mobile navigation: slide-out panel, sub-menu accordions, focus trap, Escape key
 */
export function initNavbar() {
  const menuContainer = document.getElementById("mobile-menu");
  if (!menuContainer) return;

  const toggleBtn = document.querySelector("[data-mobile-menu-toggle]");
  const closeBtn = document.querySelector("[data-mobile-menu-close]");
  const overlay = document.querySelector("[data-mobile-overlay]");
  const panel = document.querySelector("[data-mobile-panel]");
  const submenuToggles = document.querySelectorAll("[data-mobile-submenu-toggle]");

  if (!toggleBtn || !closeBtn || !overlay || !panel) return;

  function openMenu() {
    menuContainer.hidden = false;
    // Trigger reflow so transitions apply
    void panel.offsetHeight;
    overlay.classList.add("is-active");
    panel.classList.add("is-active");
    toggleBtn.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    closeBtn.focus();
    document.addEventListener("keydown", onKeyDown);
  }

  function closeMenu() {
    overlay.classList.remove("is-active");
    panel.classList.remove("is-active");
    toggleBtn.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    document.removeEventListener("keydown", onKeyDown);

    panel.addEventListener("transitionend", function handler() {
      menuContainer.hidden = true;
      panel.removeEventListener("transitionend", handler);
    });

    toggleBtn.focus();
  }

  function onKeyDown(e) {
    if (e.key === "Escape") {
      closeMenu();
      return;
    }

    // Focus trap
    if (e.key === "Tab") {
      const focusable = panel.querySelectorAll(
        'a[href], button, [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  toggleBtn.addEventListener("click", openMenu);
  closeBtn.addEventListener("click", closeMenu);
  overlay.addEventListener("click", closeMenu);

  // Sub-menu accordions
  submenuToggles.forEach((btn) => {
    btn.addEventListener("click", () => {
      const submenu = btn.nextElementSibling;
      const chevron = btn.querySelector("[data-chevron]");
      const isOpen = submenu.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", isOpen);
      if (chevron) {
        chevron.style.transform = isOpen ? "rotate(180deg)" : "";
      }
    });
  });
}
